// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { Page } from "react-page-layout";

import * as contextSelectors from "@modules/context/selectors";
import type { Client } from "@modules/context/types";
import "./access-restricted.scss";

type OwnProps = $Exact<{
  hasPermission: (permissionId: string) => boolean,
  sectionName: string,
  hideSidebar: boolean,
}>;

type PropsFromState = $Exact<{
  client: ?Client,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromLocalize,
}>;

export const AccessRestricted = (props: Props) => (
  <Page
    layout="dashboard"
    title={props.t("UNAUTHORISED_ACCESS")}
    extraProps={props}
    permissionId={{}}
    hideSidebar={props.hideSidebar}
  >
    <div className="d-flex flex-column justify-content-center align-item-center">
      <div className="access-restricted-container">
        <h3 className="access-restricted-title">{props.t("UNAUTHORISED_ACCESS")}</h3>
        <p className="access-restricted-message">
          {props.t("YOU_DO_NOT_HAVE_ACCESS_TO", { "section name": props.t(props.sectionName) })}
        </p>
        <p className="access-restricted-message">{props.t("UNAUTHORISED_ACCESS_DESCRIPTION")}</p>
      </div>
    </div>
  </Page>
);

const mapStateToProps = (state, ownProps): PropsFromState => ({
  client: contextSelectors.getClientContext(state),
});

export default compose(localize(), connect(mapStateToProps))(AccessRestricted);
